import { render, staticRenderFns } from "./cModalOpenBead.vue?vue&type=template&id=27ed4e13&scoped=true"
import script from "./cModalOpenBead.vue?vue&type=script&lang=js"
export * from "./cModalOpenBead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ed4e13",
  null
  
)

export default component.exports